import { Checkbox, FormControl, FormHelperText, Grid, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import { useEffect } from "react";

const AboutStep = ({ props }) => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    return (
        <Grid container spacing={2}>
            {/* <Grid item xs={12} container >
                <Grid item>
                    {props.emptyFormProps.includes('num_of_employees') && <FormHelperText><b style={{ color: '#d32f2f' }}>This field is required</b></FormHelperText>}
                </Grid>
            </Grid> */}
            <Grid item xs={12} sm={4}>
                <TextField
                    fullWidth
                    label="Number of employees"
                    name="num_of_employees"
                    value={props.formData.num_of_employees}
                    onChange={props.handleInputChange}
                    size="small"
                    type="number"
                    helperText={props.emptyFormProps.includes('num_of_employees') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('num_of_employees')}
                />
            </Grid>
            {/* <Grid item xs={12} container >
                <Grid item>
                    {props.emptyFormProps.includes('num_of_beds') && <FormHelperText><b style={{ color: '#d32f2f' }}>This field is required</b></FormHelperText>}
                </Grid>
            </Grid> */}
            <Grid item xs={12} sm={4}>
                <TextField
                    fullWidth
                    label="Number of beds"
                    name="num_of_beds"
                    value={props.formData.num_of_beds}
                    onChange={props.handleInputChange}
                    size="small"
                    type="number"
                    helperText={props.emptyFormProps.includes('num_of_beds') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('num_of_beds')}
                />
            </Grid>
            {/* <Grid item xs={12} container >
                <Grid item>
                    {props.emptyFormProps.includes('num_of_beds') && <FormHelperText><b style={{ color: '#d32f2f' }}>This field is required</b></FormHelperText>}
                </Grid>
            </Grid> */}
            <Grid item xs={12} sm={4}>
                <TextField
                    fullWidth
                    label="Number of outpatients per month"
                    name="num_of_outpatients"
                    value={props.formData.num_of_outpatients}
                    onChange={props.handleInputChange}
                    size="small"
                    type="number"
                    helperText={props.emptyFormProps.includes('num_of_outpatients') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('num_of_outpatients')}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    id="outlined-select-level"
                    name="institution_level_id"
                    select
                    value={props.formData.institution_level_id}
                    label="Level"
                    defaultValue=""
                    size="small"
                    fullWidth
                    onChange={e => props.handleInputChange(e)}
                    helperText={props.emptyFormProps.includes('institution_level_id') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('institution_level_id')}
                    InputLabelProps={{ shrink: true }}
                >
                    {props.level.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>

            <Grid item xs={12} sm={12}>
                <FormHelperText>Context of request</FormHelperText>
                <TextField
                    placeholder="Give a short description of the context of your hospital: urban or rural, what is the patient population like, most prevalent morbidities, etc. Try to be as detailed as possible so we can ensure a good match between you and the expert."
                    label="Requested support context"
                    id="outlined-size-small"
                    name="requested_support_description"
                    multiline
                    value={props.formData.requested_support_description}
                    rows={5}
                    maxRows={10}
                    fullWidth
                    onChange={e => props.handleInputChange(e)}
                    helperText={props.emptyFormProps.includes('requested_support_description') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('requested_support_description')}
                />
            </Grid>

            {/* <Grid item xs={12}>
                <FormControl fullWidth size="small">
                    <InputLabel id="specialty-select-label">Specialties</InputLabel>
                    <Select
                        labelId="specialty-select-label"
                        multiple
                        name="specialty_ids"
                        value={props.formData.specialty_ids}
                        onChange={props.handleSpecialtySelectChange}
                        input={<OutlinedInput label="Specialties" />}
                        renderValue={(selected) =>
                            props.specialtyFields
                                .filter(field => selected.includes(field.id))
                                .map(field => field.value)
                                .join(', ')
                        }
                    >
                        {props.specialtyFields
                            .sort((a, b) => a.value.localeCompare(b.value))
                            .map((field) => (
                                <MenuItem key={field.id} value={field.id}>
                                    <Checkbox checked={props.formData.specialty_ids.includes(field.id)} />
                                    <ListItemText primary={field.value} />
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid mt={'7.5px'} item xs={12}>
                <Grid item xs={12} container >
                    <Grid item>
                        {props.emptyFormProps.includes('work_experience_range') && <FormHelperText><b style={{ color: '#d32f2f' }}>This field is required</b></FormHelperText>}
                    </Grid>
                </Grid>
                <FormControl fullWidth size="small">
                    <InputLabel id="workxp-select-label">Years of work experience</InputLabel>
                    <Select
                        name="work_experience_range"
                        labelId="workxp-select-label"
                        value={props.formData.work_experience_range}
                        onChange={props.handleYearsOfExpRangeChange}
                        input={<OutlinedInput label="Years of work experience" />}
                    >
                        {props.yearsOfExperienceRange
                            .map((el) => (
                                <MenuItem key={el.id} value={el.value}>
                                    <ListItemText primary={el.value} />
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </Grid> */}
        </Grid>
    )
}

export default AboutStep;